export default {
  now: (state) => state.date,
  getClassifyData: (state) => state.classify.data,
  getTransactionData: (state) => state.transaction.data,
  getTransactionPeriodCondition: (state) => state.transaction.periodCondition,
  getSalesData: (state) => state.countAndSales.salesData,
  getCountPeriodCondition: (state) => state.countAndSales.countPeriodCondition,
  getCountData: (state) => state.countAndSales.countData,
  getSalesPeriodCondition: (state) => state.countAndSales.salesPeriodCondition
};
